/** USDT BEP20 withdrawal option — merged into non-English panel locales. */
export const panelWithdrawBep20ByLang = {
  fr: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'Adresse USDT BEP20 (0x…)',
  },
  ar: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'أدخل عنوان USDT BEP20 (0x…)',
  },
  ja: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'BEP20 USDTアドレスを入力 (0x…)',
  },
  ko: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'BEP20 USDT 주소 입력 (0x…)',
  },
  'zh-CN': {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': '请输入 BEP20 USDT 地址 (0x…)',
  },
  pt: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'Endereço USDT BEP20 (0x…)',
  },
  it: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'Indirizzo USDT BEP20 (0x…)',
  },
  ru: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'Адрес USDT BEP20 (0x…)',
  },
  bn: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'USDT BEP20 ঠিকানা লিখুন (0x…)',
  },
  hi: {
    'user.withdraw.form.method.bep20': 'USDT BEP20',
    'user.withdraw.form.walletPlaceholderBep20': 'USDT BEP20 पता दर्ज करें (0x…)',
  },
};
